import { StringBundle } from '../localizer/stringBundle'

export const strings = {
  bundles: [StringBundle.ATF],
  strings: [
    'DV_DP_WP_ERROR_HEADING',
    'DV_DP_WP_ERROR',
    'DV_DP_WP_END_HEADING',
    'DV_DP_WP_END',
    'DV_DP_WP_STREAM_ENDED',
    'DV_DP_WP_CREATE_INELIGIBLE_HEADING',
    'DV_DP_WP_CREATE_INELIGIBLE',
    'DV_DP_WP_JOIN_INELIGIBLE_HEADING',
    'DV_DP_WP_JOIN_INELIGIBLE',
    'DV_DP_WP_GEO_RESTRICTION_HEADING',
    'DV_DP_WP_GEO_RESTRICTION',
    'DV_DP_WP_UNSUPPORTED_BROWSER_HEADING',
    'DV_DP_WP_UNSUPPORTED_BROWSER',
  ] as const,
}
